import { render, staticRenderFns } from "./project-snippet.vue?vue&type=template&id=0de6cfa6&"
import script from "./project-snippet.vue?vue&type=script&lang=js&"
export * from "./project-snippet.vue?vue&type=script&lang=js&"
import style0 from "./project-snippet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./project-snippet.vue?vue&type=custom&index=0&blockType=fragments"
if (typeof block0 === 'function') block0(component)

export default component.exports